// extracted by mini-css-extract-plugin
export default {"container":"YmYr7","description":"s6Da9","checkboxContainer":"ZZRwA","alert":"my9oG","sectionNotificationContainer":"hjcta","labelContainer":"jsiRO","error":"fuTNL"};